// extracted by mini-css-extract-plugin
export default {"cookiesNotice":"cookies-notice_cookiesNotice__jBEvI","container":"cookies-notice_container__c92ex"};